import setAuthToken from "../../../utils/setAuthToken";
import jwt_decode from "jwt-decode";
import { GET_ERRORS, USER_LOADING } from "../../../actions/types";
import axios from "axios";
import {
  setCurrentUser,
  setCurrentUserPermission,
  forgotPasswordSuccess,
  signupSuccess,
  fetchRegexSuccess,
  fetchAvailableUrlSuccess,
  forgotPasswordSPSuccess,
  forgotPassworLogBuildSuccess
} from "../action/action";
import { dispatchError } from "../../../common/Stores/service/service";
import { api } from "common/api/api";
import OneSignal from "react-onesignal";

// Register User
export const registerUser = (userData, history) => dispatch => {
  axios
    .post("/api/users/register", userData)
    .then(res => history.push("/login")) // re-direct to login on successful register
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Login - get user token
export const loginUser = (userData, autoLogin) => dispatch => {
  axios
    .post("/api/builder/login", userData)
    .then(res => {
      // Save to localStorage
      // Set token to localStorage
      const { token } = res.data;
      const { status } = res;
      if (status === 200 && autoLogin) localStorage.setItem("jwtToken", token);
      if (status === 200) sessionStorage.setItem("jwtToken", token);
      // Set token to Auth header
      setAuthToken(token);
      // Decode token to get user data
      const decoded = jwt_decode(token);
      // Set current user
      dispatch(setCurrentUser(decoded));
      dispatch({
        type: GET_ERRORS,
        payload: ""
      });
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// LoginLogBuild - get user token
export const loginUserLogBuild = (userData, autoLogin) => dispatch => {
  const url = '/login';
  // axios
  api
    // .post("/api/logbuild/login", userData)
    .post(url, userData)
    .then(res => {
      console.log(res);
      // Save to localStorage
      // Set token to localStorage
      const { token } = res.data;
      const { status } = res;
      console.log(res);
      if (status === 201 && autoLogin) localStorage.setItem("jwtToken", token);
      if (status === 201) sessionStorage.setItem("jwtToken", token);
      // Set token to Auth header
      setAuthToken(token);
      // Decode token to get user data
      const decoded = jwt_decode(token);
      // Set current user
      dispatch(setCurrentUser(decoded));
      dispatch({
        type: GET_ERRORS,
        payload: ""
      });
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// LoginSP - get user token
export const loginUserSP = (userData, autoLogin) => dispatch => {
  axios
    .post("/api/supplier/login", userData)
    .then(res => {
      // Save to localStorage
      // Set token to localStorage
      const { token } = res.data;
      const { status } = res;
      if (status === 200 && autoLogin) localStorage.setItem("jwtToken", token);
      if (status === 200) sessionStorage.setItem("jwtToken", token);
      // Set token to Auth header
      setAuthToken(token);
      // Decode token to get user data
      const decoded = jwt_decode(token);
      // Set current user
      dispatch(setCurrentUser(decoded));
      dispatch({
        type: GET_ERRORS,
        payload: ""
      });
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// ログイン中ユーザーの権限（LbUser.permission）を API から取得し直す。
// NOTE: 権限は Cosmos DB を直接編集して変更する運用のため、トークンの値が
//       古いことがある。アプリ起動時にこれを呼んで最新の権限に揃える。
export const fetchCurrentUserPermission = () => (dispatch, getState) => {
  return api
    .get(`/lb-users/me`)
    .then(res => {
      // NOTE: 通信中にログアウト・別ユーザーでの再ログインが起きている場合が
      //       あるため、応答のユーザーと現在のログインユーザーが同じときだけ
      //       反映する（別人の権限で上書きしてしまわないように）。
      const { auth } = getState();
      if (
        !auth.isAuthenticated ||
        auth.user.uniqueCode !== res.data.uniqueCode
      ) {
        return;
      }
      dispatch(setCurrentUserPermission(res.data.permission));
    })
    .catch(() => {
      // NOTE: 取得に失敗したときはトークン内の権限のまま動かす。
      //       ここでエラー画面を出すと全画面が使えなくなるため何もしない。
    });
};

// Clear errors
export const clearErrors = () => dispatch => {
  dispatch({
    type: GET_ERRORS,
    payload: {}
  });
};

// User loading
export const setUserLoading = () => {
  return {
    type: USER_LOADING
  };
};

// Log user out
export const logoutUser = (unregisterOnesignal = false) => async dispatch => {
  if(unregisterOnesignal){
    const playerID = await OneSignal.getUserId();
    if (playerID) {
      const classification = window.location.pathname.includes("/sp/")
        ? "supplier"
        : "builder";
      api.post(`/${classification}/logmeet/device/unregister`, {
        playerId: playerID
      });
    }
  }

  // Remove token from local storage
  localStorage.removeItem("jwtToken");
  sessionStorage.removeItem("jwtToken");

  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }

  setAuthToken(false);
  dispatch(setCurrentUser({}));
  // Remove auth header for future requests
  // Set current user to empty object {} which will set isAuthenticated to false
};

export const forgotPassword = data => dispatch => {
  axios
    .put(`/api/builder/reset-password`, data)
    .then(res => dispatch(forgotPasswordSuccess(true))) // re-direct to login on successful register
    .catch(err => dispatch(dispatchError(err)));
};

export const signup = (id, data, handleError) => dispatch => {
  api
    .post(`/builder/${id}/signup`, data)
    .then(res => {
      dispatch(signupSuccess(true));
      dispatch(dispatchError(null));
    })
    .catch(err => {
      if (handleError && err.response.status === 500) {
        handleError();
      } else {
        dispatch(dispatchError(err));
      }
    });
};

export const availableUrl = id => dispatch => {
  api
    .head(`/builder/${id}/signup`)
    .then(res => {
      dispatch(fetchAvailableUrlSuccess(true));
      dispatch(dispatchError(null));
    })
    .catch(err => dispatch(dispatchError(err)));
};

export const regexSignUp = () => dispatch => {
  const url = '/system/validator-conf';
  // axios
  //   .get(`/api/common/validator-config`)
  api
    .get(url)
    .then(res => {
      dispatch(fetchRegexSuccess(res.data));
    })
    .catch(err => dispatch(dispatchError(err)));
};

export const forgotPasswordSP = data => dispatch => {
  axios
    .put(`/api/supplier/reset-password`, data)
    .then(res => dispatch(forgotPasswordSPSuccess(true))) // re-direct to login on successful register
    .catch(err => dispatch(dispatchError(err)));
};

export const forgotPasswordLogBuild = data => dispatch => {
  axios
    .put(`/api/logbuild/reset-password`, data)
    .then(res => dispatch(forgotPassworLogBuildSuccess(true))) // re-direct to login on successful register
    .catch(err => dispatch(dispatchError(err)));
};
